import { Box, Divider, Typography } from "@mui/material";
import React from "react";
import CompactProjectCard from "./project";
import ProjectKrishi2 from "./ProjectKrishi2";

const ProjectCard = () => {
  return (
    <Box
      sx={{
        flex: 1,
        mt: 10,
        mb: 10,
        background: `linear-gradient(90deg, rgba(209,230,226,1) 0%, rgba(234,238,236,1) 95%)`,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "4px",
          alignItems: "center",
          mb: 4,
        }}
      >
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: { xs: "24px", md: "30px" },
            color: "#28947F",
          }}
        >
          Investofarm Projects
        </Typography>
        <Divider
          sx={{
            borderWidth: 1,
            background: "#28947F",
            width: {
              xs: "180px",
              sm: "220px",
              md: "300px",
            },
          }}
        />
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "space-around",
          gap: "24px",
          alignItems: "center",
          px: 2,
        }}
      >
        <CompactProjectCard />

        <ProjectKrishi2 />
      </Box>
    </Box>
  );
};

export default ProjectCard;
